import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import {
  getBrandRole,
  postBrandUser,
  putBrandUser,
} from "../../../services/StoreUsers/PostStoreUsers";
import {
  getChargeDiscountMode,
  postBrandChargeDiscount,
  putBrandChargeDiscount,
} from "../../../services/ChargeDiscount.js/chargeDiscount";
import { FloatLabel } from "primereact/floatlabel";
import SuccessModal from "../../SuccessModal";
import { putBrandAppService } from "../../../services/BrandAppServices";

const AppServicePriority = ({
  appServicePriorityModalVisible,
  setAppServicePriorityModalVisible,
  sendDataToAppServicePriorityModal,
  brandId,
  selectedPriorityItemValue,
  type,
}) => {
  const navigate = useNavigate();
  const [priorityValue, setPriorityValue] = useState("");
  const [codeValue, setCodeValue] = useState("");

  const [priorityError, setPriorityError] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  useEffect(() => {
    if (selectedPriorityItemValue !== null) {
      setPriorityValue(selectedPriorityItemValue?.priority?.toString() || "");
      setCodeValue(selectedPriorityItemValue?.code?.toString() || "");
    }
  }, [selectedPriorityItemValue]);

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const handleConfirmPickup = () => {
    // Reset all previous errors

    setPriorityError("");

    let isValid = true;
    if (!priorityValue) {
      setPriorityError("Priority is required");
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        const updateData = {
          ...selectedPriorityItemValue,
          priority: priorityValue,
          code: codeValue,
        };
        putBrandAppService(brandId, updateData)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                }

                setPriorityValue("");
                setCodeValue("");

                setPriorityError("");

                setIsSubmitButtonPressed(false);
                sendDataToAppServicePriorityModal({
                  success: true,
                });
                setAppServicePriorityModalVisible(false);
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    }
  };
  const handleModalClose = () => {
    setPriorityValue("");
    setCodeValue("");

    setPriorityError("");
    setIsSubmitButtonPressed(false);
    sendDataToAppServicePriorityModal({
      success: true,
    });
    setAppServicePriorityModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={appServicePriorityModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!appServicePriorityModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                {"Edit - " + selectedPriorityItemValue?.appService?.name}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="mx-4 mt-4  ">
              <FloatLabel>
                <InputText
                  id="priorityValue"
                  value={priorityValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setPriorityValue(value);
                    }
                  }}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Priority"
                />
                <label
                  htmlFor="priorityValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Priority <span style={{ color: "red" }}>*</span>
                </label>
                {priorityError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {priorityError}
                  </p>
                )}
              </FloatLabel>
            </div>

            <div className="mx-4 mt-4">
              <FloatLabel>
                <InputText
                  id="codeValue"
                  value={codeValue}
                  onChange={(e) => setCodeValue(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Code"
                />
                <label
                  htmlFor="codeValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Code <span style={{ color: "red" }}>*</span>
                </label>
              </FloatLabel>
            </div>

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleConfirmPickup}
              disabled={isSubmitButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default AppServicePriority;
